let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ZCDp")).then(() => parcelRequire('9n6Sp'));